import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  BAR_CHART_OPTION,
  BAR_TRUNCATED_CHART_OPTION,
  INIT_CHART_OPTION_SMALL,
  PIE_CHART_COLOR_MAPPING,
  PIE_CHART_OPTION
} from '@catalogues';
import { TooltipEchartsOption } from '@models';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'distribution-charts',
  templateUrl: './distribution-charts.component.html',
  styleUrl: './distribution-charts.component.scss'
})
export class DistributionChartsComponent implements OnChanges {
  @Input() sortedTherapeuticAreaData!: string[];
  @Input() sortedPhaseData!: string[];
  @Input() sortedStageData!: string[];
  @Input() sortedAcceleratorData!: string[];
  @Input() isSidebarCollapsed!: boolean;
  @Output() expandRequested = new EventEmitter<void>();

  onExpandRequested() {
    this.expandRequested.emit();
  }

  therapeuticAreaChartTitle = 'Studies by therapeutic area';
  phaseChartTitle = 'Studies by phase';
  stageChartTitle = 'Studies by stage';
  acceleratorChartTitle = 'Accelerator drug development program';

  bar: EChartsOption = BAR_CHART_OPTION;
  barTruncated: TooltipEchartsOption = BAR_TRUNCATED_CHART_OPTION;
  pie: EChartsOption = PIE_CHART_OPTION;
  colorMap = PIE_CHART_COLOR_MAPPING;
  small: typeof INIT_CHART_OPTION_SMALL | any = INIT_CHART_OPTION_SMALL;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isSidebarCollapsed']) {
      if (this.isSidebarCollapsed) {
        this.pie = {
          ...PIE_CHART_OPTION,
          title: { ...PIE_CHART_OPTION.title, padding: [5, 5, 25, 5] }
        };
        this.bar = {
          ...BAR_CHART_OPTION,
          grid: { ...BAR_CHART_OPTION.grid, left: '10%', right: '10%' }
        };
        this.barTruncated = {
          ...BAR_TRUNCATED_CHART_OPTION,
          grid: { ...BAR_TRUNCATED_CHART_OPTION.grid, left: '10%', right: '10%' }
        };
        this.small = INIT_CHART_OPTION_SMALL;
      } else {
        this.pie = PIE_CHART_OPTION;
        this.bar = BAR_CHART_OPTION;
        this.barTruncated = BAR_TRUNCATED_CHART_OPTION;
        this.small = INIT_CHART_OPTION_SMALL;
      }
    }
  }
}
